'use client';

import React, { Fragment, type ReactNode, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const RENDER_CARDS = 15;
const CARD_TO_TRIGGER_LAZY_RENDER = 6;

/**
 * pre render about 15 on server, rest on client (giving us some performance boost)
 */
export default function LazyRenderVenueList({ children }: { children: ReactNode[] }) {
  const [show, setShow] = useState(false);
  const firstHalf = children.slice(0, RENDER_CARDS);
  const rest = children.slice(RENDER_CARDS);
  const { ref } = useInView({
    triggerOnce: true,
    // -272px on top is to handle the above fixed header and filters
    rootMargin: '-272px 0px 0px 0px',
    onChange: inView => {
      if (inView) {
        setShow(true);
      }
    }
  });

  return (
    <ul className="flex w-full flex-col items-center gap-5">
      {firstHalf.map((card, index) => {
        if (index === CARD_TO_TRIGGER_LAZY_RENDER) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <li className="w-full" ref={ref} key={index}>
              {card}
            </li>
          );
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          <li className="w-full" key={index}>
            {card}
          </li>
        );
      })}
      <>
        {show &&
          rest?.map((card, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li className="w-full" key={index}>
              {card}
            </li>
          ))}
      </>
    </ul>
  );
}
